var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch",class:[{disabled: _vm.disabled}],on:{"click":_vm.toggleSwitch}},[(_vm.falseLabel)?_c('h5',{staticClass:"label medium"},[_vm._v(" "+_vm._s(_vm.falseLabel)+" ")]):_vm._e(),_c('div',{class:['switch__slider', [`switch__slider--${_vm.size}`]],style:({
      background: _vm.switchColor,
      flexDirection: _vm.internalValue ? 'row-reverse' : 'row',
    })},[_c('div',{staticClass:"circle",class:[[`circle--${_vm.size}`]]}),_vm._t("innerText")],2),(_vm.trueLabel)?_c('h5',{staticClass:"label medium"},[_vm._v(" "+_vm._s(_vm.trueLabel)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }